import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';

export const loadFtu = async (appId, userId) => {
    let ftu = await fetchFtu(appId);

    ftu = flattenFtuForUser(ftu, userId);

    return ftu;
};

export const updateFtuItem = async (appId, userId, key, value) => {
    return updateFtu(appId, userId, { [key]: value });
};

const fetchFtu = async (appId) => {
    const db = getFirestore();
    const docRef = doc(db, 'ftu', appId);

    const docSnap = await getDoc(docRef);

    return docSnap.exists() ? { ...docSnap.data() } : {};
};

const updateFtu = async (appId, userId, updates) => {
    const ftu = await fetchFtu(appId);

    Object.keys(updates).forEach((key) => {
        if (ftu[key] && ftu[key][userId] === updates[key]) return;
        ftu[key] = {
            ...ftu[key],
            [userId]: updates[key],
        };
    });

    const db = getFirestore();
    const docRef = doc(db, 'ftu', appId);

    return setDoc(docRef, ftu);
};

const flattenFtuForUser = (ftu, userId) => {
    Object.keys(ftu).forEach((key) => {
        if (typeof ftu[key] === 'object') {
            if (ftu[key][userId] !== undefined) {
                ftu[key] = ftu[key][userId];
            } else {
                delete ftu[key];
            }
        }
    });

    return ftu;
};
